import React, { useState, useEffect } from 'react';
import './Carousel.css';

const RUTA_BASE = process.env.PUBLIC_URL || '';
const RUTA_CARPETA = `${RUTA_BASE}/img/proyectos/proyecto inicio`;

const SLIDES = [
  { fallback: '1.jpeg', webp: '1.webp' },
  { fallback: '2.jpg', webp: '2.webp' },
  { fallback: '3.jpg', webp: '3.webp' },
  { fallback: '4.jpg', webp: '4.webp' },
  { fallback: '5.jpeg', webp: '5.webp' },
].map(({ fallback, webp }) => ({
  fallback: encodeURI(`${RUTA_CARPETA}/${fallback}`),
  webp: encodeURI(`${RUTA_CARPETA}/${webp}`),
}));

const NOMBRES_PROYECTOS = [
  'Olympus Sport Center - CABA',
  'Río Grande - Tierra del Fuego',
  'Pirelli - Planta Merlo',
  'Club y Biblioteca Mariano Moreno',
  'Pastas Gaeta - Marcos Paz',
];

const INTERVALO_AUTO = 5000;

function ImagenCarrusel({ slide, alt, className, fetchPriority, loading }) {
  return (
    <picture className={className ? `${className}-picture` : undefined}>
      <source type="image/webp" srcSet={slide.webp} />
      <img
        src={slide.fallback}
        alt={alt}
        className={className}
        decoding="async"
        fetchPriority={fetchPriority}
        loading={loading}
        draggable={false}
      />
    </picture>
  );
}

function Carousel() {
  const [indice, setIndice] = useState(0);

  const siguiente = () => {
    setIndice((i) => (i + 1) % SLIDES.length);
  };

  const anterior = () => {
    setIndice((i) => (i - 1 + SLIDES.length) % SLIDES.length);
  };

  useEffect(() => {
    const id = setInterval(siguiente, INTERVALO_AUTO);
    return () => clearInterval(id);
  }, [indice]);

  return (
    <section className="carousel" aria-label="Galería de proyectos">
      <div className="carousel__banner" aria-hidden="true">
        Proyectos destacados
      </div>
      <div className="carousel__contenedor">
        {SLIDES.map((slide, i) => (
          <div
            key={slide.fallback}
            className={`carousel__slide ${i === indice ? 'carousel__slide--activo' : ''}`}
            aria-hidden={i !== indice}
          >
            <ImagenCarrusel
              slide={slide}
              alt={NOMBRES_PROYECTOS[i]}
              className="carousel__imagen"
              fetchPriority={i === 0 ? 'high' : 'low'}
              loading={i === 0 ? 'eager' : 'lazy'}
            />
            <div className="carousel__overlay" aria-hidden />
          </div>
        ))}
      </div>

      <div className="carousel__texto" key={indice}>
        <h2 className="carousel__titulo">
          {NOMBRES_PROYECTOS[indice].split(/\s+/).map((palabra, i) => (
            <span
              key={i}
              className="carousel__titulo-palabra"
              style={{ animationDelay: `${i * 0.18}s` }}
            >
              {palabra}
            </span>
          ))}
        </h2>
      </div>

      <button
        type="button"
        className="carousel__btn carousel__btn--prev"
        onClick={anterior}
        aria-label="Imagen anterior"
      >
        <span className="carousel__btn-icon" aria-hidden="true">‹</span>
      </button>
      <button
        type="button"
        className="carousel__btn carousel__btn--next"
        onClick={siguiente}
        aria-label="Siguiente imagen"
      >
        <span className="carousel__btn-icon" aria-hidden="true">›</span>
      </button>

      <div className="carousel__thumbs" role="tablist" aria-label="Seleccionar proyecto">
        {SLIDES.map((slide, i) => (
          <div key={slide.fallback} className="carousel__thumb-wrap">
            <button
              type="button"
              role="tab"
              aria-selected={i === indice}
              aria-label={`Ir a ${NOMBRES_PROYECTOS[i]}`}
              className={`carousel__thumb ${i === indice ? 'carousel__thumb--activo' : ''}`}
              onClick={() => setIndice(i)}
            >
              <span className="carousel__thumb-img-wrap">
                <ImagenCarrusel slide={slide} alt="" className="carousel__thumb-img" loading="lazy" />
              </span>
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Carousel;
